import * as React from 'react';

function BreadcrumbItem({ text, url }) {
  return (
    <div className='breadcrumb-item'>
      <a href={url}>{text}</a>
    </div>
  );
}

export default function Breadcrumbs({ items = [] }) {
  if (Array.isArray(items) == false || items.length == 0) { return null }

  return (
    <div className='breadcrumb'>
      {items.map(item => <BreadcrumbItem key={item.text} text={item.text} url={item.url} />)}
    </div>
  )
}
